import { uploadEntityAttachments, deleteAttachment } from '@/lib/entity-attachments';

export interface SpecificationFileAttachment {
  id: string;
  file_name: string;
  file_type: string;
  file_size: number;
  file_url: string;
  created_at: string;
  created_by: string;
  created_by_user?: {
    display_name?: string | null;
  };
}

export async function uploadSpecificationAttachments(
  specificationId: string | undefined,
  files: File[],
  companyId: string,
  userId: string
): Promise<SpecificationFileAttachment[]> {
  return uploadEntityAttachments('specification', specificationId, files, companyId, userId);
}

export function deleteSpecificationAttachment(
  attachmentId: string,
  userId: string | undefined
): Promise<boolean> {
  return deleteAttachment(attachmentId, userId);
}
